import { render, staticRenderFns } from "./ProcessNotification.vue?vue&type=template&id=bc8ef06a&scoped=true"
import script from "./ProcessNotification.vue?vue&type=script&lang=js"
export * from "./ProcessNotification.vue?vue&type=script&lang=js"
import style0 from "./ProcessNotification.vue?vue&type=style&index=0&id=bc8ef06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8ef06a",
  null
  
)

export default component.exports